import React, { memo, useMemo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ActionSelector from 'Pods/ThreeDStudio/Shared/ActionSelector/ActionSelector'
import AIEngineSelector from 'Pods/ThreeDStudio/Shared/AIEngineSelector/AIEngineSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setInputImage, setPrompt } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { setGenerationAction } from 'Pods/ThreeDStudio/Store/actions/schema'
import { ACTION } from 'Pods/ThreeDStudio/Store/constants'

import AdvancedSettings from './Components/AdvancedSettings/AdvancedSettings'
import ExtraQualitySelector from './Components/ExtraQualitySelector/ExtraQualitySelector'
import MaterialSelector from './Components/MaterialSelector/MaterialSelector'
import PolyCountSelector from './Components/PolyCountSelector/PolyCountSelector'
import PolygonTypeSelector from './Components/PolygonTypeSelector/PolygonTypeSelector'
import SmartLowPolySelector from './Components/SmartLowPolySelector/SmartLowPolySelector'
import UseCaseSelector from './Components/UseCaseSelector/UseCaseSelector'

function ModelSettings() {
  const t = useTranslation()
  const generationAction = useThreeDStudioStore(state => state.schema.generationAction)

  const tabs = useMemo(() => ({
    image: {
      id: ACTION.IMAGE_TO_3D,
      onClick: () => setGenerationAction(ACTION.IMAGE_TO_3D),
      isActive: generationAction === ACTION.IMAGE_TO_3D,
      setInputImage,
    },
    text: {
      id: ACTION.TEXT_TO_3D,
      onClick: () => setGenerationAction(ACTION.TEXT_TO_3D),
      isActive: generationAction === ACTION.TEXT_TO_3D,
      placeholder: t('leftSide.modelSettings.promptPlaceholder'),
      setPrompt,
    },
  }), [generationAction, t])

  const items = useMemo(() => [
    {
      id: 'AIEngine',
      component: AIEngineSelector,
    },
    {
      id: 'ExtraQuality',
      component: ExtraQualitySelector,
    },
    {
      id: 'SmartLowPoly',
      component: SmartLowPolySelector,
    },
    {
      id: 'Polycount',
      component: PolyCountSelector,
    },
    {
      id: 'PolygonType',
      component: PolygonTypeSelector,
    },
    {
      id: 'Material',
      component: MaterialSelector,
    },
  ], [])

  return (
    <div className="model-settings">
      <div className="model-settings__content">
        <ActionSelector
          id="model-settings"
          tabs={tabs}
          sliceName="modelSettings"
          storeSchemaKey="generationModelSchema"
        />
        <UseCaseSelector />
        <AdvancedSettings items={items} />
      </div>
    </div>
  )
}

export default memo(ModelSettings)
